import React, { useEffect, useState } from 'react'
import { Close, Container, HeaderArea, Title, Fundo, ContainerButtons } from './style';

import deletIcon from "../../assets/icons/icons-8-trash.png"
import IconCloseGray from "../../assets/icons/icon-close-gray.svg"

import { theme } from '../../styles/theme';
import {H6} from '../../styles/stylesTypography'

const CardRightV2 = ({ ...props }) => {
    const [isOpen, setIsOpen] = useState(false);
    // const [animation, setAnimation] = useState(false);

    const close = () => {
        setIsOpen(false);
        props.updateIsOpen(false)
    }

    useEffect(() => {
        setIsOpen(props.open)
    }, [props.open])


    return (
        // <ScreenArea isOpen={isOpen} onClick={() => setIsOpen(false)}>
        <>
            {isOpen && (
                <Fundo onClick={() => close()}></Fundo>
            )}
            <Container isOpen={isOpen} animation={props.animation}>

                <HeaderArea>
                    <div style={{
                        width: '100%',
                        display: 'flex',
                        flexDirection: 'row',
                        alignItems: 'center',
                        justifyContent: 'space-between',
                    }}>
                        <Title>
                            <H6 color={theme.colors.gray.Cinza_5} fontWeight={800}>
                                {props.title}
                            </H6>
                        </Title>
                        
                        <ContainerButtons>
                            <div>
                                {props.isEdit && (
                                    <img  
                                    className="delete" 
                                    onClick={() => props.updateDelete()} 
                                    src={deletIcon} alt="" 
                                    style={{ cursor: 'pointer' }}
                                    />
                                )}
                            </div>

                            <Close onClick={() => close()}> 
                                <img src={IconCloseGray} alt="Ícone de fechar" />
                            </Close>
                        </ContainerButtons>
                    </div>
                </HeaderArea>

                {props.children}
            </Container>
        </>
        // </ScreenArea>
    )
}

export default CardRightV2;